import { httpService } from "../httpService.service";

// Full site visit card by id — used by the AI search preview (F-14).
export const getSiteVisitById = (id, callback, errCallback) =>
  httpService.get(`/api/Site/getSiteVisit?id=${id}`, callback, errCallback);

// Backend contract — F-03 stalled escalation & F-09 repeat visit.

// F-03 — manual trigger to recompute/flag stalled site visits. PM/Admin only.
// (SiteVisitResponse now carries isStalled: bool and stalledSince: date?.)
export const escalateStalledSiteVisits = (callback, errCallback) =>
  httpService.post(
    `/api/Site/escalateStalledSiteVisits`,
    {},
    callback,
    errCallback
  );

// F-09 — repeat visit. Existing DuplicateSiteVisit now clears visit dates,
// status, results, media and data-check counts (inherits IP / cluster /
// location / contacts). Used by the "Repeat visit" action on completed visits.
export const duplicateSiteVisit = (siteVisitId, callback, errCallback) =>
  httpService.post(
    `/api/Site/duplicateSiteVisit?siteVisitId=${siteVisitId}`,
    {},
    callback,
    errCallback
  );
